import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { BrandLockup } from "@/shell/CandidateFlow";

export function RecruiterVerifyEmailPending() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#FBFAFE",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px 16px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 400,
          background: "#FFFFFF",
          borderRadius: 16,
          padding: 40,
          boxShadow: "0 1px 4px rgba(45,30,90,0.08)",
          textAlign: "center",
        }}
      >
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 28 }}>
          <BrandLockup />
        </div>

        <h1 style={{ margin: "0 0 20px", fontSize: 26, fontWeight: 700, color: "#17131F" }}>
          Check your inbox
        </h1>

          <div
            style={{
              width: 64, height: 64, borderRadius: "50%",
              background: "rgba(122,107,224,0.1)",
              display: "flex", alignItems: "center", justifyContent: "center",
              margin: "0 auto 20px",
            }}
          >
            <Mail size={28} strokeWidth={1.75} color="#7A6BE0" />
          </div>
          <p style={{ margin: "0 0 12px", fontSize: 15, fontWeight: 600, color: "#17131F" }}>
            Verify your email address
          </p>
          <p style={{ margin: "0 0 24px", fontSize: 14, color: "#7C7590", lineHeight: 1.6 }}>
            We've sent a verification link to your email address. Click it to activate your account and access the recruiter portal.
          </p>
          <p style={{ margin: "0 0 20px", fontSize: 13, color: "#7C7590" }}>
            Didn't get it? Check your spam folder, or{" "}
            <Link to="/auth/register" style={{ color: "#7A6BE0" }}>
              try registering again
            </Link>
            .
          </p>
          <Link
            to="/auth/login"
            style={{
              display: "inline-block",
              padding: "11px 24px",
              fontSize: 14,
              fontWeight: 600,
              color: "#7A6BE0",
              border: "1px solid #7A6BE0",
              borderRadius: 8,
              textDecoration: "none",
            }}
          >
            Back to sign in
          </Link>
      </div>
    </div>
  );
}
